module.exports = __webpack_public_path__ + "img/slide04.9b03b42a.png";